import { LitElement } from 'lit';
/**
 * Base class for all JustVue components.
 * Forces light DOM so Tailwind utilities (applied via global stylesheet or
 * CDN) pass through the component without shadow-DOM boundary isolation.
 */
export class JVElement extends LitElement {
    createRenderRoot() {
        return this;
    }
}
